import React from 'react';
import classNames from 'classnames';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import MergedTable from '../MergedTable';
import Station from '../Station';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import styles from './Body.module.css';
import tableMergeEnum from '../../../../enums/tableMergeEnum';

const Body = props => {
  const {
    goBack,
    stations,
    onMerge,
    parentStation,
    childStations,
    setParentStation,
    setChildStation,
    onlyMergedTable,
    toggleMergedTables,
    sortFunction,
    onlySensorTables,
    toggleTableSensor,
  } = props;

  const renderLeftSection = () => {
    return (
      <div className={styles.leftSection}>
        {renderHeader()}
        <div className={styles.mergedTablesWrapper}>
          {showMergedTables()}
        </div>
      </div>
    );
  };

  const showMergedTables = () => {
    const isVisible = table => onlyMergedTable ? table?.merges.length > 0 ? true : false : true;
    return (
      stations.map(table =>
        !isVisible(table) ? null :
          <div key={table.id} className={classNames({ [styles.tableGroup]: true, [styles.group]: table?.merges.length > 0 })}>
            <MergedTable
              active={parentStation && parentStation?.id === table?.id} minus={table?.merges.length > 0}
              station={table}
              onClick={(pStation, actionType) => setParentStation(pStation, actionType, tableMergeEnum.PARENT, {})}
              flexBasis={'13.2%'}
              parent={true}
            />
            {table?.merges && table.merges.sort(sortFunction).map(mTable =>
              <MergedTable
                key={mTable.id}
                minus={true}
                station={mTable}
                onClick={(cStation, actionType) => setParentStation(cStation, actionType, tableMergeEnum.CHILD, table)}
                flexBasis={'13.2%'}
              />
            )}
          </div>
      )
    );
  };

  const renderRightSection = () => {
    const isMerged = station => station?.merges.length > 0 || (parentStation && parentStation?.id === station.id);
    return (
      <div className={styles.rightSection}>
        <div className={styles.tablesWrapper}>
          {!parentStation ? null :
            stations.map(station =>
              isMerged(station)
                ? null
                : <Station key={station.id} active={childStations.has(station.id)} station={station} onClick={setChildStation} flexBasis={'30%'} />
            )
          }
        </div>
        <div className={styles.buttonsWrapper}>
          <Button className={styles.btn} onClick={onMerge} disabled={isButtonDisabled()}>
            <span className={styles.mergeTxt}>MERGE</span>
          </Button>
        </div>
      </div>
    );
  };

  const isButtonDisabled = () => {
    if (!!parentStation && childStations.size !== 0)
      return false;
    else return true;
  };

  const renderHeader = () => {
    return (
      <div className={styles.headerWrapper}>
        {window.ReactNativeWebView
          ? <img src={backImg} className={styles.backImage} alt='' onClick={goBack} />
          : null}
        <Checkbox checked={onlyMergedTable} onChange={toggleMergedTables} />
        <span>Merged Tables</span>
        <Checkbox checked={onlySensorTables} onChange={toggleTableSensor} />
        <span>With Sensors</span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {renderLeftSection()}
      {renderRightSection()}
    </div>
  );
};

export default Body;
